/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { useLabels } from '@/wpt-lib/pdf/useData';
import { label } from '@/wpt-lib/utils/label';

const TeachingBenchmarks = ({
    teachingExpectationsAreas = {},
    teachingExpectationLevel = {},
}: Partial<{
    teachingExpectationsAreas: { [area: string]: boolean };
    teachingExpectationLevel: { [area: string]: string };
}>) => {
    const areas = useLabels('teachingExpectationsAreas');

    return (
        <>
            {Object.entries(teachingExpectationsAreas)
                .filter(([, a]) => a)
                .map(([area]) => (
                    <Row key={area} widths={[80, 20]}>
                        <ValueCell single label="Aligned Benchmark" value={label(areas, area)} />
                        <ValueCell single label="Academic Level" value={teachingExpectationLevel[area]} />
                    </Row>
                ))}
        </>
    );
};

export default TeachingBenchmarks;
